<!-- 车场通道信息变更上报接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "cmd": "reportParkMonthTicket"
        },
        responseCode: {
          "data": {},
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动上报车场月票订单变更信息到第三方接入系统",
          urlPattern: this.commonUrls.third + "reportParkMonthTicket",
          precondition: "无",
          fitSystem: "云停车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency: "实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'parkCode',
                info2: '是',
                info3: 'String',
                info4: '停车场编号(财务主体)'
              },{
                info1: 'parkName',
                info2: '是',
                info3: 'String',
                info4: '停车场名称(财务主体)'
              },
              {
                info1: 'customerName',
                info2: '是',
                info3: 'String',
                info4: '车主姓名'
              },
              {
                info1: 'carCode',
                info2: '是',
                info3: 'String',
                info4: '车牌号码(x,x,x)'
              },
              {
                info1: 'carportNumber',
                info2: '是',
                info3: 'Integer',
                info4: '可用车位数'
              },
              {
                info1: 'vipTime',
                info2: '是',
                info3: 'String',
                info4: 'VIP有效期'
              },
              {
                info1: 'vipTimeValidityList',
                info2: '是',
                info3: 'JOSNArray',
                info4: 'vip有效期'
              },
              {
                info1: 'customVipName',
                info2: '是',
                info3: 'String',
                info4: 'VIP名称'
              },
              {
                info1: 'formerPrice',
                info2: '是',
                info3: 'BigDecimal',
                info4: '原价'
              },
              {
                info1: 'favorPrice',
                info2: '是',
                info3: 'BigDecimal',
                info4: '折扣价(折后实际价格)'
              },
              {
                info1: 'ticketRecordType',
                info2: '是',
                info3: 'Integer',
                info4: '流水类型（0开通,1续期,2退款,3冻结,4解冻,5已恢复,6已删除,7修改）'
              },
              {
                info1: 'favorPrice',
                info2: '是',
                info3: 'BigDecimal',
                info4: '折扣价(折后实际价格)'
              },
              {
                info1: 'operator',
                info2: '是',
                info3: 'String',
                info4: '操作员'
              },
              {
                info1: 'operateTime',
                info2: '是',
                info3: 'String',
                info4: '操作时间(yyyyMMddHHmmss)'
              },
              {
                info1: 'refundPrice',
                info2: '是',
                info3: 'BigDecimal',
                info4: '退款金额'
              },
              {
                info1: 'refundStatus',
                info2: '是',
                info3: 'Integer',
                info4: '退款状态'
              },
              {
                info1: 'remark',
                info2: '是',
                info3: 'String',
                info4: '备注'
              },
              {
                info1: 'paymentMode',
                info2: '是',
                info3: 'Integer',
                info4: '支付方式'
              },
              {
                info1: 'payOrigin',
                info2: '是',
                info3: 'Integer',
                info4: '支付来源'
              },
              {
                info1: 'paymentMode',
                info2: '是',
                info3: 'Integer',
                info4: '支付方式'
              },
              {
                info1: 'paymentModeRemark',
                info2: '是',
                info3: 'String',
                info4: '支付方式备注'
              },
              {
                info1: 'settlementType',
                info2: '是',
                info3: 'Integer',
                info4: '结算类型（0时间结算，1储值结算，2次数结算）'
              },
              {
                info1: 'createTime',
                info2: '是',
                info3: 'String',
                info4: '创建时间'
              },
              {
                info1: 'statStatus',
                info2: '是',
                info3: 'Integer',
                info4: '统计状态 0 未统计， 1已统计'
              },
              {
                info1: 'actualBalance',
                info2: '是',
                info3: 'Integer',
                info4: '实际充值到账户的金额（即充值金额 * 充值比例）'
              },
              {
                info1: 'adjustValue',
                info2: '是',
                info3: 'BigDecimal',
                info4: '冲正流水的调整值'
              },
              {
                info1: 'frozenTime',
                info2: '是',
                info3: 'String',
                info4: '冻结时间(yyyyMMddHHmmss)'
              },
              {
                info1: 'parkDataList',
                info2: '是',
                info3: 'JSONArray',
                info4: '月票适用车场列表'
              }


            ]
          }, {
            titleName: 'vipTimeValidityList',
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'validFrom',
                info2: '是',
                info3: 'String',
                info4: '起始时间(yyyyMMddHHmmss)'
              },
              {
                info1: 'validTo',
                info2: '是',
                info3: 'String',
                info4: '截止时间(yyyyMMddHHmmss)'
              }
            ]
          }, {
            titleName: 'parkList',
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'parkCode',
                info2: '是',
                info3: 'String',
                info4: '车场编号'
              },
              {
                info1: 'parkName',
                info2: '是',
                info3: 'String',
                info4: '车场名称'
              }
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: []
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportParkMonthTicket.vue